<template>
  <div>
    <a-card :bordered="false">
      <template #title>
        对局列表<i @click="refresh" style="cursor: pointer;margin-left: 15px" :class="loading ? 'el-icon-loading' : 'el-icon-refresh-right'"></i>
      </template>
      <div v-loading="loading" element-loading-background="#111111">
        <el-timeline v-if="matchList.length > 0" style="padding: 20px;">
          <bt-timeline-item placement="top" v-for="(match, matchIndex) in matchList" :key="matchIndex">
            <template #timestamp>
              <div style="display: flex">
                <span>{{ DateUtil.format(match['matchDateTime']) }}</span>
<!--                <a-icon type="star" v-if="!collectedMatchIdSet.has(match['id'])" style="margin-left: 10px;padding-top: 1px;cursor: not-allowed"/>-->
<!--                <a-icon type="star" v-if="collectedMatchIdSet.has(match['id'])" theme="filled" style="margin-left: 10px;padding-top: 1px;color: gold;cursor: not-allowed"/>-->
              </div>
            </template>
            <template #dot>
              <div style="background-color: #e5e5e5;width: 10px;height: 10px"></div>
            </template>
            <div style="background-color: rgba(89,89,89,0.2);font-size: 20px;">
              <div class="match-container" style="width: 100%;height: 73px;color: white;display: flex;justify-content: space-between;">
                <!--地图图片、服务器名字等-->
                <div @click="expandMatch(match)" class="match-info-container" style="display: flex;justify-content: flex-start;cursor: pointer">
                  <div class="mapImage">
                    <el-image style="width: 115px;height: 73px;" :src="Bf1Map[match['gameMap']]['image']"/>
                  </div>
                  <div style="width: 100%;margin-left: 10px;display: flex;flex-direction: column;justify-content: space-around;">
                    <div class="match-server-name-text" style="width: 100%;font-weight: 500;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                      {{ match['serverName'] }}
                    </div>
                    <div class="match-server-info-text" style="width: 100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                      {{ Bf1ServerType[match['serverType']] }} - {{ BF1Mode[match['gameMode']]['name'] }} - {{ Bf1Map[match['gameMap']]['name'] }}
                    </div>
                  </div>
                </div>
                <!--右侧对局结果-->
                <div @click="expandMatch(match)" class="match-result-container" style="display: flex;align-items: center;justify-content: flex-end;cursor: pointer;margin-right: 10px;">
                  <div style="display: flex;flex-direction: column;justify-content: space-around;align-items: end;">
                    <div class="match-result-text" :style="'color:' + dict[match['matchResult']]['color']">
                      {{ dict[match['matchResult']]['name'] }}
                    </div>
                    <div class="match-result-duration">
                      {{ DateUtil.toDurationMinutesString(match['matchActualDuration']) }}
                    </div>
                  </div>
                  <div style="margin-left: 10px">
                    <img class="match-team-image" :src="match['teamId'] === 0 ? Bf1Map[match['gameMap']]['teamOne']['image'] : Bf1Map[match['gameMap']]['teamTwo']['image']" width="53" height="53" alt="">
                  </div>
                </div>
<!--                <div style="display: flex;align-items: center;padding-left: 20px;padding-right: 20px;margin-left: 23px;border-left: 1px solid rgb(66,66,66);cursor: pointer">-->
<!--                  <i v-if="!collectedMatchIdSet.has(match['id'])" class="el-icon-star-off"></i>-->
<!--                  <i v-if="collectedMatchIdSet.has(match['id'])" class="el-icon-star-on"></i>-->
<!--                </div>-->
              </div>

              <el-collapse-transition>
                <div v-loading="matchItemsLoading" element-loading-background="#111111" v-if="match['expand']" style="border-top: 1px solid #8a8a8a">
                  <a-row>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="击杀" :value="objectUtil.nullToDefault(match['kills'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="死亡" :value="objectUtil.nullToDefault(match['deaths'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="KD" :value="objectUtil.nullToDefault(match['kd'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="KPM" :value="objectUtil.nullToDefault(match['kpm'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="SPM" :value="objectUtil.nullToDefault(match['spm'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="命中率" :value="objectUtil.nullToDefault(match['accuracyRatio'], '—') + '%'"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="爆头率" :value="objectUtil.nullToDefault(match['headShotsRatio'], '—') + '%'"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="firstDataXs" :sm="firstDataSm" :md="firstDataMd" :lg="firstDataLg" :xl="firstDataXl" :xxl="firstDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="first-data" title="总得分" :value="objectUtil.nullToDefault(match['score'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="射击数" :value="objectUtil.nullToDefault(match['shots'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="命中数" :value="objectUtil.nullToDefault(match['hits'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="爆头数" :value="objectUtil.nullToDefault(match['headshots'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="协助击杀" :value="objectUtil.nullToDefault(match['killAssists'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="占点数" :value="objectUtil.nullToDefault(match['flagsCaptured'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="守点数" :value="objectUtil.nullToDefault(match['flagsDefended'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="救援数" :value="objectUtil.nullToDefault(match['revives'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="治疗数" :value="objectUtil.nullToDefault(match['heals'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="维修数" :value="objectUtil.nullToDefault(match['repairs'], '—')"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="结果" :value="dict[match['matchResult']]['name']"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic class="secondary-data" title="时长" :value="DateUtil.toDurationMinutesString(match['matchActualDuration'])"/>
                      </a-card-grid>
                    </a-col>
                    <a-col :xs="secondaryDataXs" :sm="secondaryDataSm" :md="secondaryDataMd" :lg="secondaryDataLg" :xl="secondaryDataXl" :xxl="secondaryDataXxl">
                      <a-card-grid style="width: 100%;">
                        <a-statistic :value-style="{ color: match['skill'] < 0 ? '#71c02b' : match['skill'] > 0 ? '#f86d77' : '#ffffff' }" class="secondary-data" title="技巧值" :value="objectUtil.nullToDefault(match['skill'], '—')"/>
                      </a-card-grid>
                    </a-col>
                  </a-row>
                  <a-row :gutter="[16,16]" style="padding-left: 16px;padding-right: 16px;padding-bottom: 8px">
                    <a-col v-for="(item, itemIndex) in match['items']" :key="itemIndex" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="6">
                      <a-row style="padding: 10px;background-color: rgba(131,131,131,0.2);color: white;">
                        <a-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14" :xxl="14">
                          <el-image style="margin:10px;" :src="item['image']"/>
                        </a-col>
                        <a-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" :xxl="10">
                          <a-row>
                            <a-col :xs="12" :sm="10" :md="10" :lg="10" :xl="10" :xxl="10" style="height: 72px;">
                              <a-card-grid class="item-card" style="width: 100%;height: 100%;display: flex;align-items: center">
                                <a-statistic class="item-data" title="时长" :value="DateUtil.toDurationString(objectUtil.nullToDefault(item['seconds'], 0))"/>
                              </a-card-grid>
                            </a-col>
                            <a-col :xs="12" :sm="14" :md="14" :lg="14" :xl="14" :xxl="14" style="height: 72px;">
                              <a-card-grid class="item-card" style="width: 100%;height: 100%;display: flex;align-items: center">
                                <a-statistic class="item-data" title="类型" :value="objectUtil.nullToDefault(item['category'], '—')"/>
                              </a-card-grid>
                            </a-col>
                          </a-row>
                        </a-col>
                      </a-row>
                      <a-row style="padding:10px;background-color: rgba(169,169,169,0.2);color: white;">
                        <div style="font-size: 18px;font-weight: 500;line-height: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                          {{ item['name'] }}
                        </div>
                      </a-row>
                      <a-row style="padding: 10px;background-color: rgba(89,89,89,0.2);color: white;">
                        <a-col span="6">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="击杀数" :value="objectUtil.nullToDefault(item['kills'], '—')"/>
                          </a-card-grid>
                        </a-col>
                        <a-col span="6" v-if="!hasDestroyedGuidSet.has(item['guid'])">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="爆头数" :value="objectUtil.nullToDefault(item['headshots'], '—')"/>
                          </a-card-grid>
                        </a-col>
                        <a-col span="6">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="KPM" :value="objectUtil.nullToDefault(item['kpm'], '—')"/>
                          </a-card-grid>
                        </a-col>
                        <a-col span="6" v-if="!hasDestroyedGuidSet.has(item['guid'])">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="效率比" :value="objectUtil.nullToDefault(item['efficiency'], '—')"/>
                          </a-card-grid>
                        </a-col>
                        <a-col span="6" v-if="hasDestroyedGuidSet.has(item['guid'])">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="摧毁数" :value="objectUtil.nullToDefault(item['destroyed'], '—')"/>
                          </a-card-grid>
                        </a-col>
                      </a-row>
                      <a-row style="padding: 10px;background-color: rgba(89,89,89,0.2);color: white;">
                        <a-col span="24" style="height: 49px;" v-if="hasDestroyedGuidSet.has(item['guid'])">

                        </a-col>
                        <a-col span="6" v-if="!hasDestroyedGuidSet.has(item['guid'])">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="射击数" :value="objectUtil.nullToDefault(item['shots'], '—')"/>
                          </a-card-grid>
                        </a-col>
                        <a-col span="6" v-if="!hasDestroyedGuidSet.has(item['guid'])">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="命中数" :value="objectUtil.nullToDefault(item['hits'], '—')"/>
                          </a-card-grid>
                        </a-col>
                        <a-col span="6" v-if="!hasDestroyedGuidSet.has(item['guid'])">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="命中率" :value="objectUtil.nullToDefault(item['accuracyRatio'], '—')"/>
                          </a-card-grid>
                        </a-col>
                        <a-col span="6" v-if="!hasDestroyedGuidSet.has(item['guid'])">
                          <a-card-grid class="item-card" style="width: 100%;">
                            <a-statistic class="item-data" title="爆头率" :value="objectUtil.nullToDefault(item['headShotsRatio'], '—')"/>
                          </a-card-grid>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </div>
              </el-collapse-transition>
            </div>
          </bt-timeline-item>
        </el-timeline>
        <div v-else style="height: 350px;color: white;display: flex;justify-content: center;align-items: center;font-size: 20px">
          暂无对局数据
        </div>
        <a-row v-if="total > 10" type="flex" justify="end" style="margin-bottom: 20px;">
          <a-col :span="24" style="display: flex;justify-content: center;margin-bottom: 10px;">
            <a-pagination :page-size="10" :total="total" @change="pageChange"/>
          </a-col>
          <a-col :span="24" style="display: flex;justify-content: center">
            <div style="line-height: 30px;color: white">共 {{total}} 场对局</div>
          </a-col>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>

import {DateUtil} from "../utils/date-util";
import {Bf1Map, BF1Mode, Bf1ServerType} from "../enum/bf1-enum";
import {objectUtil} from "../utils/object-util";
import {batchQueryPersonaMatchItemApi} from "../request/api/persona";
import BtTimelineItem from "./BtTimelineItem.vue";

export default {
  name: "matchList",
  components: {
    BtTimelineItem
  },
  computed: {
    objectUtil() {
      return objectUtil
    },
    DateUtil() {
      return DateUtil
    },
  },
  props: {
    matchList: {
      type: Array,
      default: () => []
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    loading: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      Bf1ServerType: Bf1ServerType,
      BF1Mode: BF1Mode,
      Bf1Map: Bf1Map,
      
      firstDataXxl: 3,
      firstDataXl: 6,
      firstDataLg: 6,
      firstDataMd: 6,
      firstDataSm: 12,
      firstDataXs: 12,

      secondaryDataXxl: 2,
      secondaryDataXl: 4,
      secondaryDataLg: 6,
      secondaryDataMd: 6,
      secondaryDataSm: 6,
      secondaryDataXs: 12,

      xxl: 8,
      xl: 8,
      lg: 8,
      md: 8,
      sm: 8,
      xs: 8,

      collectedMatchIdSet: new Set(),

      hasDestroyedGuidSet: new Set(
          [
            "8BD0FABD-DCCE-4031-8156-B77866FCE1A0",
            "C71A02C3-608E-42AA-9179-A4324A4D4539",
            "1F37F90F-F85E-A4EA-0CA0-977FBC04DB6C",
            "67B44E81-D1DA-B485-D185-D6520CF59E4B",
            "7CA00F5A-E5DE-3FD9-ECAD-7D4FC5C1AC80",
            "003FCC0A-2758-8508-4774-78E66FA1B5E3",
            "BBFC5A91-B2FC-48D2-8913-658C08072E6E",
            "E7825334-17D9-3BA1-D59C-8497155B8DBB",
            "B30F9312-6887-46C5-873F-2670906856AE",
            "87E38FC3-022D-4A88-80B5-6E3BD58C320F",
            "A3C6FC16-2DF6-4719-9A5F-E079CDB928F3",
            "887AA8B4-878C-4943-B688-BAE3E9A5A4E7",
            "56C8EC6A-6667-547E-8393-B047A1BCB730",
            "A9D9062B-FFEC-429E-9DD5-E24EB9D9C51B",
            "EFB07B81-BBA3-413E-AF40-221CC104C21D",
            "ADF5B89F-5854-43C4-BAD4-46C9D1C020F5",
            "4289E1A4-5EBE-7FA3-52D8-AFDB8ED374BA",
            "C3272C97-B92E-4E2A-B842-06EF06DC2CB0",
            "DF87BA6E-961D-4F14-86B4-AE5F1326BA14",
            "4AA28E71-6FDA-A50B-80A8-B52D070FF884",
            "4723A26F-98AE-55BA-7B3F-3AE7E0E3B0C7",
            "189D43F5-E653-416B-B6D6-D0137C28375D",
            "A79071D2-5C4F-0BA8-0ECC-FCB1376E2FBA",
            "41A7B28A-FE39-4FC8-9AA3-9AD7BC4F6A3C",
            "690ABB5C-7B7E-4609-B37A-2DB46C2F6287",
            "A3ED808E-1525-412B-8E77-9EB6902A55D2",
            "12689F49-C72C-6BFE-07E9-A26258C0FCA0",
            "2E5402EF-6303-B756-AEE9-E7926AB5FEF8",
            "EB79DB6E-8A05-9618-3368-34DCBE3C3C17",
            "2B0D6EA6-8978-6400-7E85-C8ED33E3B6B3",
            "91ECED06-9066-470D-BFE0-A1122118A5B3",
            "B3BFBF74-6475-598C-C097-06DA0375F14A",
            "7FEDA17B-6A27-1946-A02E-AA72A72FBCD7",
            "F73DA041-0864-4782-BEDD-D9C08D86DA7D",
            "705E9B4E-5E97-FD3C-9979-A4F2D11AE06F",
            "6D6C110E-EBC9-42CC-BB7A-ACA156638D3C",
            "EA1C556F-DC5A-4764-BE8F-E661AF2B2C3B",
            "1A7DEECF-4F0E-E343-9644-D6D91DCAEC12",
            "33A894B8-BCE1-8689-3064-7308BBC781CC",
            "AD78AD89-1824-B113-75EC-CFD3180A367D",
            "E305E0C1-FED8-00FD-747A-C9282C51F524",
            "CB7D595C-0376-4C72-A8B8-1455965EA81E",
            "A92386FB-7D4B-0E8A-6F2B-CC63FC2A8D78",
            "12F1002B-97FA-490B-822F-E621C6827BFB",
            "FA740EE6-6C1E-2F97-D48B-0EF8D1C7D11B",
            "045085BF-D9E2-476F-9363-C11DD9BDDC61"
          ]
      ),

      matchItemsLoading: false,

      dict: {
        1: {
          name: '胜利',
          color: 'rgb(255, 205, 0)'
        },
        2: {
          name: '失败',
          color: 'rgb(252, 118, 118)'
        },
        3: {
          name: '平局',
          color: 'rgb(156,204,245)'
        },
        4: {
          name: '离开',
          color: 'rgb(255, 255, 255)'
        },
      }
    }
  },
  methods: {
    pageChange(value) {
      this.$emit("page-change", value)
    },
    expandMatch(match) {
      if (match['expand'] === null) {
        this.$set(match, 'expand', true)
      }
      else {
        this.$set(match, 'expand', !match['expand'])
      }
      if (match['expand'] && match['items'] == null) {
        this.matchItemsLoading = true;
        batchQueryPersonaMatchItemApi(match['personaId'], match['id']).then((res) => {
          match['items'] = res['data']['data'].sort((o1, o2) => {
            if (o1['kills'] > o2['kills']) {
              return -1;
            }
            else {
              return 1;
            }
          })
        }).finally(() => {
          this.matchItemsLoading = false
        })
      }
    },
    getServerTypeTextColor(serverType) {
      if (serverType === 1) {
        return '#98FB98'
      }
      return '#87CEFF'
    },
    refresh() {
      if (this.loading) {
        return
      }
      this.$emit("refresh")
    },
  }
}
</script>

<style scoped>
/** a-card卡片黑色风格 **/
.ant-card {
  background: rgba(17,17,17,0.7);
}
::v-deep .ant-card-head {
  color: white;
  background-color: #1c1c1c;
  border-bottom: none;
}
::v-deep .ant-card-body {
  padding: 0;
}
.ant-card-grid {
  box-shadow: none;
}
::v-deep .ant-card-head-title {
  font-size: 20px;
}



::v-deep .el-timeline-item__tail {
  border-left: 2px solid #e5e5e5;
}

::v-deep .el-timeline-item__timestamp {
  color: white;
  font-size: 15px;
}

::v-deep .ant-pagination-prev>.ant-pagination-item-link,
::v-deep .ant-pagination-next>.ant-pagination-item-link{
  background-color: rgba(89,89,89,0.2);
  border: none;
  color: white;
}
::v-deep .ant-pagination-prev>.ant-pagination-item-link:hover,
::v-deep .ant-pagination-next>.ant-pagination-item-link:hover{
  background-color: rgb(100, 100, 100);
}
::v-deep .ant-pagination-disabled.ant-pagination-prev>.ant-pagination-item-link,
::v-deep .ant-pagination-disabled.ant-pagination-prev>.ant-pagination-item-link:hover,
::v-deep .ant-pagination-disabled.ant-pagination-next>.ant-pagination-item-link,
::v-deep .ant-pagination-disabled.ant-pagination-next>.ant-pagination-item-link:hover{
  color: #3d3d3d;
  background-color: #282828;;
}

::v-deep .ant-pagination-item-active {
  border: none;
  background-color: rgb(126, 124, 124) !important;
}
::v-deep .ant-pagination-item,
::v-deep .ant-pagination-jump-next,
::v-deep .ant-pagination-jump-prev{
  border: none;
  background-color: rgba(89,89,89,0.2);
}
::v-deep .ant-pagination-item:hover {
  background-color: rgb(100, 100, 100);
}
::v-deep .ant-pagination-item a,
::v-deep .ant-pagination-jump-next .ant-pagination-item-ellipsis,
::v-deep .ant-pagination-jump-next .anticon-double-right,
::v-deep .ant-pagination-jump-prev .ant-pagination-item-ellipsis,
::v-deep .ant-pagination-jump-prev .anticon-double-left{
  color: white;
}

::v-deep .item-data>.ant-statistic-title,
::v-deep .item-data>.ant-statistic-content,
::v-deep .item-data>.ant-statistic-content .ant-statistic-content-value-decimal {
  font-size: 15px;
}

::v-deep .item-card.ant-card-grid {
  padding: 0;
}

::v-deep .el-timeline-item__timestamp {
  font-size: 18px;
}

/** <576px **/
@media screen and (max-width: 576px) {
  .mapImage {
    display: none;
  }
  .match-team-image {
    display: none;
  }
  .match-info-container {
    width: 60%;
  }
  .match-result-container {
    width: 30%;
  }
  .match-server-name-text {
    font-size: 17px;
  }
  .match-server-info-text {
    font-size: 12px;
  }
  .match-result-text,
  .match-result-duration{
    font-size: 18px;
  }
  ::v-deep .first-data>.ant-statistic-title,
  ::v-deep .first-data>.ant-statistic-content,
  ::v-deep .first-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 20px;
  }
  ::v-deep .secondary-data>.ant-statistic-title,
  ::v-deep .secondary-data>.ant-statistic-content,
  ::v-deep .secondary-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 13px;
  }
}

/** ≥576px **/
@media screen and (min-width: 576px) {
  .mapImage {
    display: none;
  }
  .match-info-container {
    width: 60%;
  }
  .match-result-container {
    width: 40%;
  }
  .match-server-name-text,
  .match-server-info-text{
    font-size: 16px;
  }
  ::v-deep .first-data>.ant-statistic-title,
  ::v-deep .first-data>.ant-statistic-content,
  ::v-deep .first-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 22px;
  }
  ::v-deep .secondary-data>.ant-statistic-title,
  ::v-deep .secondary-data>.ant-statistic-content,
  ::v-deep .secondary-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 13px;
  }
}
/** ≥768px **/
@media screen and (min-width: 642px) {
  .mapImage {
    display: none;
  }
  .match-info-container {
    width: 70%;
  }
  .match-result-container {
    width: 30%;
  }
  .match-server-name-text,
  .match-server-info-text{
    font-size: 18px;
  }
  ::v-deep .first-data>.ant-statistic-title,
  ::v-deep .first-data>.ant-statistic-content,
  ::v-deep .first-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 23px;
  }
  ::v-deep .secondary-data>.ant-statistic-title,
  ::v-deep .secondary-data>.ant-statistic-content,
  ::v-deep .secondary-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 15px;
  }
}
/** ≥768px **/
@media screen and (min-width: 768px) {
  .mapImage {
    display: block;
  }
  .match-info-container {
    width: 50%;
  }
  .match-result-container {
    width: 30%;
  }
  .match-server-name-text,
  .match-server-info-text{
    font-size: 20px;
  }
  ::v-deep .first-data>.ant-statistic-title,
  ::v-deep .first-data>.ant-statistic-content,
  ::v-deep .first-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 24px;
  }
  ::v-deep .secondary-data>.ant-statistic-title,
  ::v-deep .secondary-data>.ant-statistic-content,
  ::v-deep .secondary-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 15px;
  }
}
/** ≥992px **/
@media screen and (min-width: 992px) {
  .mapImage {
    display: block;
  }
  .match-info-container {
    width: 60%;
  }
  .match-result-container {
    width: 30%;
  }
  ::v-deep .first-data>.ant-statistic-title,
  ::v-deep .first-data>.ant-statistic-content,
  ::v-deep .first-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 25px;
  }
  ::v-deep .secondary-data>.ant-statistic-title,
  ::v-deep .secondary-data>.ant-statistic-content,
  ::v-deep .secondary-data>.ant-statistic-content .ant-statistic-content-value-decimal{
    font-size: 15px;
  }
}
/** ≥1200px **/
@media screen and (min-width: 1200px) {
  .mapImage {
    display: block;
  }
  .match-info-container {
    width: 70%;
  }
  .match-result-container {
    width: 30%;
  }
}
/** ≥1600px **/
@media screen and (min-width: 1600px) {

}
</style>